import React, { useEffect, useState } from 'react';
import { CircularProgress, Container, Grid, IconButton } from '@mui/material';
import { getPOPerformanceDetails } from '../action';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import PoBookingTable from '../Component/PoBookingTable';
import PoSummaryCard from '../Component/PoSummaryCard';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const PoPerformanceDetails = () => {
  const [isLoading, setLoading] = useState(false);
  const [poDetailsData, setPODetaildata] = useState({});
  const { company_details } = useSelector((state) => {
    return {
      company_details: state.reportReducer.company_details,
    };
  });
  const navigate = useNavigate();

  const handleBackClick = () => navigate(-1);

  const getPODetailsData = async () => {
    setLoading(true);

    const payload = {
      manufacturer_id: company_details.id,
    };
    const { data, error, message } = await getPOPerformanceDetails(payload);
    if (!error) {
      setPODetaildata(data);
      setLoading(false);
    } else {
      setLoading(false);
      return toast.error(message);
    }
  };

  useEffect(() => {
    if (company_details?.id) {
      getPODetailsData();
    }
  }, [company_details?.id]);
  return (
    <>
      <Container
        maxWidth='true'
        sx={{
          pl: '2rem',
          height: window.innerHeight,
          overflowY: 'auto',
          pb: 10,
          pt: 5,
        }}
      >
        <IconButton
          aria-label='Back'
          onClick={handleBackClick}
          sx={{ mr: 2, ml: -1 }}
        >
          <ArrowBackIcon
            sx={{
              color: '#F59C1E',
              fontSize: 30,
            }}
          />
        </IconButton>
        <Grid
          container
          spacing={2}
          justifyContent='center'
        >
          <Grid
            item
            xs={12}
          >
            <PoSummaryCard
              orderSummary={poDetailsData?.po_quantity_by_status}
            />
          </Grid>
          <Grid
            item
            xs={12}
          >
            {' '}
            {isLoading ? (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '50vh',
                }}
              >
                <CircularProgress sx={{ alignSelf: 'center' }} />
              </div>
            ) : (
              <PoBookingTable
                orderData={
                  poDetailsData?.sales_quantity_detailed_report?.booking_info
                }
                yearData={
                  poDetailsData?.sales_quantity_detailed_report?.year_data
                }
              />
            )}
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default PoPerformanceDetails;
